'use client'

import { ArrowUpRight } from "lucide-react";

type Props = { onBook: () => void };

export function CtaSection({ onBook }: Props) {
  return (
    <section id="visit" className="relative overflow-hidden bg-ink py-32 text-nude">
      <div className="mx-auto max-w-[1600px] px-6 text-center md:px-12">
        <p className="eyebrow !text-rose-gold-soft">N° 04</p>
        <h2 className="mx-auto mt-6 max-w-4xl font-display text-5xl md:text-8xl">
          Reserve a chair. <em className="text-rose-gold">Reserve an hour.</em>
        </h2>
        <p className="mx-auto mt-8 max-w-md text-sm text-nude/70">
          No phone tag. No deposits lost. Choose your artist, lock your time, pay securely — all in under sixty seconds.
        </p>
        <button
          onClick={onBook}
          className="mt-10 inline-flex items-center gap-2 border border-nude bg-nude px-10 py-5 text-[0.7rem] uppercase tracking-editorial text-ink transition-all hover:bg-rose-gold hover:border-rose-gold hover:text-nude"
        >
          Book Your Stylist
          <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
}
